import { Directive, inject, Input, TemplateRef } from '@angular/core';

@Directive({ selector: '[ctrTab]', standalone: true })
export class TabDirective {
  @Input() tabTitle: string | undefined;

  public template = inject(TemplateRef<unknown>);
}
